import api from './axios';

export function createDebit(data) {
  return api.post('/debits', data).then(r => r.data);
}

function resolveMesRef(filtros = {}) {
  if (filtros.mesRef) return filtros.mesRef;
  if (filtros.dataReferencia) return filtros.dataReferencia;

  if (filtros.ano && filtros.mes) {
    return `${filtros.ano}-${String(filtros.mes).padStart(2, '0')}`;
  }

  if (filtros.year && filtros.month) {
    return `${filtros.year}-${String(filtros.month).padStart(2, '0')}`;
  }

  return undefined;
}

export function listDebits(usuario, filtros = {}) {
  const mesRef = resolveMesRef(filtros);
  const params = { usuario, ...filtros };

  if (mesRef) {
    params.mesRef = mesRef;
    const [year, month] = mesRef.split('-').map(Number);

    if (year && month) {
      params.year = year;
      params.month = month;
      params.ano = year;
      params.mes = month;
    }
  }

  return api.get('/debits', { params }).then(r => r.data);
}

export function updateDebit(id, data, options = {}) {
  const payload = { ...data, ...options };
  return api.put(`/debits/${id}`, payload, { params: options }).then(r => r.data);
}

export function deleteDebit(id, options = {}) {
  return api.delete(`/debits/${id}`, { params: options, data: options });
}

export function getDebitDateRange() {
  return api.get('/debits/date-range').then(r => r.data);
}

export function togglePayDebit(id, options = {}) {
  return api.patch(`/debits/${id}/pay`, options, { params: options }).then(r => r.data);
}

export function listPendingDebitApprovals(options = {}) {
  return api.get('/debits/pending-approvals', { params: options }).then((r) => r.data);
}

export function approveDebitParticipation(id, payload = {}) {
  return api.patch(`/debits/${id}/participation/approve`, payload).then((r) => r.data);
}

export function rejectDebitParticipation(id, payload = {}) {
  return api.patch(`/debits/${id}/participation/reject`, payload).then((r) => r.data);
}
